import { createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import { checkToken } from '../misc/utils'


export interface IShopifyStore {
	primaryDomain: string,
	myshopifyDomain: string,
	currentAppInstallation: any,
	source: boolean,
	review: boolean,
	admin: boolean
}
// Define a type for the slice state
interface ShopifyStoreState {
    shopifyStore: IShopifyStore | null,
    status: string,
    error: string | undefined,
}

// Define the initial state usiEng that type
const initialState: ShopifyStoreState = {
    shopifyStore: null,
    status: '',
    error: ''
}

declare global {
  interface Window {
    $crisp: any[];
  }
}

export const getShopifyStoreInfo =  createAsyncThunk('getShopifyStoreInfo', async (_, store) => {
	const token = await checkToken(store)
	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/store/shop`, {
		headers: {
			Authorization: `Bearer ${token}`
		},
		method: 'GET',
		credentials: 'include',
	})

	return response.json()
})

export const getAppInstallValidity =  createAsyncThunk('getAppInstallValidity', async (theme_id: string, store) => {
	const token = await checkToken(store)
	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/store/assets/settings_data?theme_id=${theme_id}`, {
		headers: {
			Authorization: `Bearer ${token}`
		},
		method: 'GET',
		credentials: 'include',
	})

	return response.json()
})


export const shopifyStoreSlice = createSlice(
	{
		name: 'shopifyStore',
		initialState,
		reducers: {},
		extraReducers(builder) {
			builder
			// getShopifyStoreInfo
			.addCase(getShopifyStoreInfo.fulfilled, (state, action) => {
				state.status = 'succeeded'
				console.log("getStoreInfo : fulfilled")
				state.shopifyStore = {
					primaryDomain: action?.payload?.shop?.primaryDomain?.host || '',
					myshopifyDomain: action?.payload?.shop?.myshopifyDomain || '',
					currentAppInstallation:  action?.payload?.currentAppInstallation,
					source:  action?.payload?.source,
					review:  action?.payload?.review,
					admin:  action?.payload?.admin
				}
				localStorage.setItem('shop', JSON.stringify({
					myshopifyDomain: action?.payload?.shop?.myshopifyDomain || '',
				}))

				if (window?.$crisp?.push) {
						window.$crisp.push(["set", "session:data", [[
						["myshopifyDomain", `${action?.payload?.shop?.myshopifyDomain}`]
					]]]);
				}
			})
		}
	}
)

export default shopifyStoreSlice.reducer
